import styled, { keyframes } from "styled-components";

const medalShimmer = keyframes`
  0% { transform: translateX(-150%); }
  100% { transform: translateX(250%); }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  width: 100%;
`;

export const Title = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
  white-space: nowrap;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const ModalButton = styled.button`
  -webkit-appearance: none;
  appearance: none;
  border-radius: 100px;
  border: 1px solid #0e4a96;
  background: linear-gradient(176deg, #05224f 3.6%, #0f4e9e 96.4%);
  box-shadow: 0 4px 4px 0 #081120;

  display: inline-flex;
  height: 28px;
  padding: 8px;
  align-items: center;
  justify-content: center;
  gap: 6px;

  cursor: pointer;
  outline: none;

  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.065px;
  font-family: Figtree;
`;
export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Section = styled.div`
  border-radius: 24px;
  border: 1px solid #142743;
  background: #18181f;
  display: flex;
  width: 100%;
  padding: 24px 16px 16px 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 400px;
  flex: 1;
`;

export const PodiumContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 109px;
`;

export const PodiumUsernameWrapper = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const PodiumGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  gap: 24px;
  @media (max-width: 760px) {
    gap: 12px;
  }
`;

export const PodiumCard = styled.div`
  border-radius: 20px 20px 4px 4px;

  background: ${(props) =>
    props.$rank === 1
      ? "linear-gradient(213deg, #ffbd25 6.81%, #d87b00 52.91%, #c58300 93.19%)"
      : props.$rank === 2
        ? "linear-gradient(213deg, #8E8E8E 6.81%, #A8A8A8 43.77%, #8E8E8E 93.19%)"
        : props.$rank === 3
          ? "linear-gradient(213deg, #823305 6.81%, #9F430B 43.77%, #893605 93.19%)"
          : "#142743"};

  box-shadow: ${(props) =>
    props.$rank === 1
      ? "0 1.6px 2.1px 4px #FFDB89 inset"
      : props.$rank === 2
        ? "0 1.6px 3px 0px #DADADA inset"
        : props.$rank === 3
          ? "0 1.6px 3px 0px #EEA14E inset"
          : "none"};

  border: ${(props) =>
    props.$rank === 1
      ? "2.4px solid #FB0"
      : props.$rank === 2
        ? "2.4px solid #AAA"
        : props.$rank === 3
          ? "2.4px solid #813205"
          : "0.5px solid #325682"};

  height: ${(props) =>
    props.$rank === 1
      ? "100px"
      : props.$rank === 2
        ? "80px"
        : props.$rank === 3
          ? "60px"
          : "44px"};

  width: 251px;

  @media (max-width: 840px) {
    width: 150px;
  }

  @media (max-width: 600px) {
    width: 100px;
  }

  display: flex;
  /* padding: 2px 44px 2px 25px; */
  align-items: center;
  gap: 10px;
  outline: none;
  @media (max-width: 389px) {
    width: 90px;
  }
`;

export const PodiumIcon = styled.img`
  width: 32px;
  height: 32px;

  @media (max-width: 840px) {
    width: 20px;
    height: 20px;
  }
`;

export const PodiumAvatarWrapper = styled.div`
  position: relative;
  display: flex;
  width: 120px;
  height: 120px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  border: 2px solid #164e95;
  overflow: visible;
  @media (max-width: 768px) {
    width: 88px;
    height: 88px;
  }
`;

export const PodiumAvatar = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`;

export const PodiumAvatarFallback = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #18181f;

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

export const PodiumMedalBadge = styled.div`
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  height: 22px;
  padding: 0 8px;
  justify-content: center;
  overflow: hidden;
  align-items: flex-start;
  gap: 2px;

  border-radius: 100px;
  border: ${(p) => {
    if (p.$rank === 1) return "0.5px solid #EEA015";
    if (p.$rank === 2) return "0.5px solid #BCBCBC";
    if (p.$rank === 3) return "0.5px solid #612501";
    if (p.$rank >= 4 && p.$rank <= 5) return "0.5px solid #FFD86B";
    if (p.$rank >= 6 && p.$rank <= 10) return "0.5px solid #BCBCBC";
    return "0.5px solid #345884";
  }};
  background: ${(p) => {
    if (p.$rank === 1)
      return "linear-gradient(213deg, #FFBD25 6.81%, #A85F00 52.91%, #C58300 93.19%)";
    if (p.$rank === 2)
      return "linear-gradient(41deg, #1C1C1C -5.1%, #464646 36.56%, #8E8E8E 92.26%)";
    if (p.$rank === 3)
      return "linear-gradient(213deg, #391501 6.81%, #632500 43.77%, #381500 93.19%)";
    if (p.$rank >= 4 && p.$rank <= 5)
      return "linear-gradient(213deg, #FFE066 6.81%, #E5B800 52.91%, #8C6500 93.19%)";
    if (p.$rank >= 6 && p.$rank <= 10)
      return "linear-gradient(41deg, #1C1C1C -5.1%, #464646 36.56%, #8E8E8E 92.26%)";
    return "#142743";
  }};

  & > img {
    display: block;
    flex: 0 0 20px;
    min-width: 20px;
    min-height: 20px;
    width: 20px;
    height: 20px;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
  }
`;

export const PodiumColumn = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const PodiumRank = styled.div`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.9px;
  opacity: 0.6;
`;

export const PodiumName = styled.div`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  margin-top: 6.5px;
  letter-spacing: -0.36px;

  cursor: pointer;

  width: 100%;
  display: flex;
  justify-content: center;
  white-space: normal;
  z-index: 10;
  overflow: visible;
  text-overflow: unset;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 840px) {
    max-width: 120px;
    font-size: 14px;
  }

  @media (max-width: 600px) {
    max-width: 85px;
    font-size: 14px;
  }

  @media (max-width: 389px) {
    width: 60px;
    font-size: 14px;
  }
`;

export const LeaderboardGrid = styled.div`
  display: grid;
  gap: 16px;
  align-self: stretch;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 490px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const LeaderboardItemWrapper = styled.div`
  position: relative;
  min-width: 0;
`;

export const LeaderboardItem = styled.div`
  display: flex;
  overflow: hidden;
  align-items: center;
  gap: 4px;
  padding: 12px 44px 12px 12px;
  height: 44px;
  position: relative;
  width: 100%;
  max-width: 445px;
  min-width: 0;

  cursor: pointer;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background:
    linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(24, 24, 31, 0.2) 100%),
    #0e0e11;

  &:hover {
    text-decoration: underline;
  }
`;

export const LeaderboardMedalBadge = styled.img`
  position: absolute;
  right: 3px;
  top: -4px;
  width: 37px;
  height: 37px;
  cursor: pointer;
  z-index: 2;
`;

export const LeaderboardMedalShimmer = styled.div`
  position: absolute;
  right: 3px;
  top: -4px;
  width: 37px;
  height: 37px;
  pointer-events: none;
  z-index: 3;
  overflow: hidden;
  -webkit-mask-image: url(${(p) => p.$src});
  mask-image: url(${(p) => p.$src});
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      110deg,
      transparent 30%,
      rgba(255, 255, 255, 0.6) 50%,
      transparent 70%
    );
    animation: ${medalShimmer} 2.5s linear infinite;
    will-change: transform;
  }
`;

export const LeaderboardMedalPopup = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  max-width: 317px;
  width: 100%;
  padding: 16px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #142743;
  background: #081120;
  overflow: hidden;
  z-index: 30;
`;

export const LeaderboardMedalPopupMedal = styled.img`
  position: absolute;
  right: 3px;
  top: -4px;
  width: 37px;
  height: 37px;
  pointer-events: none;
`;

export const LeaderboardMedalPopupText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.21px;
  margin: 0;
  padding-right: 40px;
`;

export const LeaderboardMedalPopupBold = styled.span`
  font-weight: 700;
`;

export const LeaderboardRank = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.08px;
  min-width: 23px;
  flex-shrink: 0;
`;

export const LeaderboardName = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  text-transform: lowercase;
  letter-spacing: -0.21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  flex: 1 1 0;
  min-width: 0;
`;

export const EmptyStateCard = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
`;
export const TemplateColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: ${(p) => p.$alignItems || "flex-start"};
  gap: ${(p) => p.$gap || 0};
`;

export const TemplateRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  flex-wrap: wrap;
  gap: 16px;

  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #142743")};
  padding-bottom: 16px;

  @media (max-width: 768px) {
    display: none;
  }
`;
export const MobileTemplateRow = styled.div`
  display: none;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;

  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #142743")};
  padding-bottom: 16px;

  @media (max-width: 768px) {
    display: flex;
  }
`;
export const TemplateLabel = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.5;
  letter-spacing: -0.21px;
`;
export const TemplateValue = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;
export const EmptyStateIcon = styled.div`
  font-size: 48px;
  display: flex;
  justify-content: center;
`;

export const EmptyStateTitle = styled.h3`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const EmptyStateText = styled.p`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.21px;
  opacity: 0.8;
`;

export const PublishButton = styled.button`
  display: flex;
  width: 180px;
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  border-radius: 100px;
  background: #fff;
  align-items: center;
  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const TemplatesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TemplateFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FooterText = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
`;

export const Pagination = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const PaginationButton = styled.button`
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: ${(props) =>
    props.disabled ? "rgba(255, 255, 255, 0.3)" : "rgba(255, 255, 255, 0.8)"};
  padding: 8px 16px;
  border-radius: 8px;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;
  letter-spacing: -0.21px;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:disabled {
    opacity: 0.5;
  }
`;

export const PaginationCurrent = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;
